import React from 'react';
import { Table as AntdTable, Row, Col } from 'antd';
import clsx from 'clsx';

import { Block } from '@atoms';
import { Pagination } from '@molecules';
import { DEFAULT_DELAY } from '@constants';

import s from './styles.module.less';

const Table = ({ isFetching, dataSource, header, columns, pagination, rowKey, showHeader = false, className }) => (
  <div>
    {header}
    <AntdTable
      className={clsx(s.custom, className)}
      loading={{ delay: DEFAULT_DELAY, spinning: isFetching }}
      dataSource={dataSource}
      rowKey={rowKey}
      columns={columns}
      showHeader={showHeader}
      pagination={false}
    />
    <Block as={Row} justify="center" size="small" style={{ marginTop: 1 }}>
      <Col>
        <Pagination
          data-testid="table-pagination"
          current={pagination.page}
          pageSize={pagination.perPage}
          total={pagination.total}
          onChange={pagination.handleChange}
        />
      </Col>
    </Block>
  </div>
);

export default Table;
